import { createContext } from 'react'

import { EAgentKeys, TAgentCentralizedContext } from '~/features/agents/models'

// eslint-disable-next-line import/prefer-default-export
export const AGENT_ID_QUERY_KEY = 'agent'

export const CHAT_RULES_PLACEHOLDER =
  'Example: Keep responses brief and conversational and do not offer to transfer to a human.'

export const EMAIL_RULES_PLACEHOLDER =
  'Example: Always include a professional sign-off with the business name. Avoid using slang or overly casual language.'

export const PHONE_RULES_PLACEHOLDER =
  "Example: Always ask for the caller's name at the beginning of the conversation. If the caller seems frustrated, offer to transfer them to a human representative."

export const TEXT_RULES_PLACEHOLDER =
  'Example: Always respond in a friendly and concise manner. If the customer asks about pricing, direct them to the website pricing page. Keep responses under 160 characters when possible.'

export const MAX_GLOBAL_RULES_LENGTH = 3000

export const AGENT_LIMIT_MIN = 1
export const AGENT_LIMIT_MAX = 200

export const DEBOUNCE_TIME = 500

export const AgentCentralizedContext =
  createContext<TAgentCentralizedContext | null>(null)

export const AGENT_MERGE_FIELDS = [
  {
    label: 'Assistant Name',
    value: EAgentKeys.agentName,
  },
  {
    label: 'Assistant Email',
    value: EAgentKeys.agentEmail,
  },
  {
    label: 'Business Name',
    value: EAgentKeys.businessName,
  },
  {
    label: 'Site Link',
    value: EAgentKeys.siteLink,
  },
] as const
